import React, { Fragment, useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import CustomContext from '../../_helper/Customizer'
import { useRoleBasedMenu } from './Menu'
import SidebarIcon from './SidebarIcon'
import SidebarLogo from './SidebarLogo'
import SidebarMenu from './SidebarMenu'
import { getIdData } from '../../lib/studentinfo'
import { StudentHeaderInfo } from '../../Components/StudentManagement/StudentHeaderInfo'

const Sidebar = (props) => {
	const customizer = useContext(CustomContext)
	const { toggleIcon } = useContext(CustomContext)
	const location = useLocation()
	const id = location.pathname.split('/').pop()
	const defaultLayout = Object.keys(customizer.layout)
	const layout = id ? id : defaultLayout

	const [studentData, setStudentData] = useState(null)
	const roleBasedMenuItems = useRoleBasedMenu(studentData)
	const [mainmenu, setMainMenu] = useState(roleBasedMenuItems)

	// Function to extract student ID/slug from URL
	const getStudentIdFromPath = () => {
		const path = location.pathname
		const pathParts = path.split('/')

		// Priority list of patterns
		const patterns = [
			'student-tasks',
			'student-schedule',
			'student-timeline',
			'student-college-list',
			'student-deadlines',
			'student-financial-aid',
			'student-12-activities',
			'student-main-essay',
			'student-supplemental-essay',
			'student-additional-info',
			'student-brag-sheet',
			'student-personal-questions',
			'student-911-college-list',
			'student-grade-list',
			'student-grade-list-2',
			'student-lessons',
			'student-goal-questions',
			'student-booklist',
			'student-911-activities',
			'student-911-awards',
			'student-911-congressional-awards',
			'instructor-studentlessonforgrade',
			'instructor-studentlessoneditforgrade',
			'instructor-studentlessonedit'
		]

		for (const pattern of patterns) {
			if (path.includes(`/${pattern}/`)) {
				const index = pathParts.findIndex((part) => part === pattern)
				return index !== -1 ? pathParts[index + 1] : null
			}
		}

		// Fallback for special cases like checklist-edit
		if (path.includes('/checklist-edit/')) {
			const index = pathParts.findIndex((part) => part === 'checklist-edit')
			return index !== -1 ? pathParts[index + 1] : null
		}

		return null
	}

	useEffect(() => {
		const fetchStudentInfo = async () => {
			const studentId = getStudentIdFromPath()
			if (studentId) {
				try {
					const info = await getIdData(studentId)
					if (info && info.length > 0) {
						setStudentData({
							id: studentId,
							role: info[0].role,
							layout: layout
						})
					}
				} catch (error) {
					console.error('Error fetching student info for sidebar:', error)
					setStudentData(null)
				}
			} else {
				setStudentData(null)
			}
		}

		fetchStudentInfo()
	}, [location.pathname, layout])

	// Update mainmenu when roleBasedMenuItems changes
	useEffect(() => {
		setMainMenu(roleBasedMenuItems)
	}, [roleBasedMenuItems])

	const [width, setWidth] = useState(0)

	const handleScroll = () => {
		if (window.scrollY > 400) {
			// if (
			//   customizer.settings.sidebar.type.split(' ').pop() ===
			//   'material-type' ||
			//   customizer.settings.sidebar.type.split(' ').pop() ===
			//   'advance-layout'
			// )
			document.querySelector('.sidebar-main').className = 'sidebar-main hovered'
		} else {
			if (document.getElementById('sidebar-main')) document.querySelector('.sidebar-main').className = 'sidebar-main'
		}
	}

	useEffect(() => {
		document.querySelector('.left-arrow').classList.add('d-none')
		window.addEventListener('resize', handleResize)
		handleResize()
		window.addEventListener('scroll', handleScroll)
		handleScroll()
		return () => {
			window.removeEventListener('scroll', handleScroll)
			window.removeEventListener('resize', handleResize)
		}
	}, [layout])

	const handleResize = () => {
		setWidth(window.innerWidth - 500)
	}

	const activeClass = () => {
		// document.querySelector('.sidebar-link').classList.add('active');
		document.querySelector('.bg-overlay1').classList.add('active')
	}

	const setNavActive = (item) => {
		// Toggle the active state of the clicked item
		item.active = !item.active

		// Update the menu state
		const updatedMenu = mainmenu.map((menuItems) => {
			const updatedItems = menuItems.Items.map((Items) => {
				// Reset all other items to inactive
				if (Items !== item) {
					Items.active = false
				}

				// Handle parent items that contain the clicked item
				if (Items.children && Items.children.includes(item)) {
					Items.active = true
					document.querySelector('.sidebar-links').classList.add('active')
				}

				// Handle nested children
				if (Items.children) {
					Items.children.forEach((submenuItems) => {
						if (submenuItems.children && submenuItems.children.includes(item)) {
							Items.active = true
							submenuItems.active = true
						}
					})
				}

				return Items
			})
			return { ...menuItems, Items: updatedItems }
		})

		document.querySelector('.bg-overlay1').classList.remove('active')
		setMainMenu(updatedMenu)
	}

	const closeOverlay = () => {
		document.querySelector('.bg-overlay1').classList.remove('active')
		document.querySelector('.sidebar-links').classList.remove('active')
	}

	return (
		<Fragment>
			<div
				className="bg-overlay1"
				onClick={() => {
					closeOverlay()
				}}
			></div>
			<div className={`sidebar-wrapper ${toggleIcon ? 'close_icon' : ''}`} sidebar-layout="stroke-svg">
				<SidebarIcon />
				<SidebarLogo />
				{/* Student Info in Sidebar - Only show when a student is selected and sidebar is open */}
				{getStudentIdFromPath() && !toggleIcon && (
					<div className="student-sidebar-info">
						<StudentHeaderInfo studentId={getStudentIdFromPath()} isSidebar={true} />
					</div>
				)}
				{/* sidebartoogle={sidebartoogle} */}
				<SidebarMenu
					setMainMenu={setMainMenu}
					props={props}
					setNavActive={setNavActive}
					activeClass={activeClass}
					width={width}
					mainmenu={mainmenu}
				/>
			</div>
		</Fragment>
	)
}

export default Sidebar
